import { Patient, PatientQuery } from '@dreryk/egabinet-patient-frontend-api';

import { refetchCqrsQuery, useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, NotFoundPanel } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type PatientFormLoaderRenderProps = {
   patient: Patient;
};
type PatientUnconfirmedPanelLoaderProps = {
   readonly patientId: string | undefined;
   readonly children: (renderProps: PatientFormLoaderRenderProps) => JSX.Element;
};

export const refetchPatientQuery = async (): Promise<void> => {
   await refetchCqrsQuery(PatientQuery);
};

export const PatientFormLoader = (props: PatientUnconfirmedPanelLoaderProps): JSX.Element => {
   const { data: patient, error: patientError, fetching: patientFetching } = useCqrsGet<Patient>(
      () => {
         const query = new PatientQuery();
         query.id = Slot.of(Number(props.patientId));
         return query;
      },
      {
         enabled: Number.isInteger(Number(props.patientId)),
      }
   );

   if (patientFetching) {
      return <LoaderSpinner />;
   }

   if (patientError) {
      return <NotFoundPanel />;
   }

   return props.children({ patient: patient });
};
